import { AnnouncementStatus, AnnouncementPriority } from "@mimber/schema"

export const STATUS_CONFIG: Record<
  AnnouncementStatus,
  { label: string; color: string }
> = {
  [AnnouncementStatus.DRAFT]: { label: "Draft", color: "default" },
  [AnnouncementStatus.SCHEDULED]: { label: "Scheduled", color: "processing" },
  [AnnouncementStatus.PUBLISHED]: { label: "Published", color: "success" },
}

export const PRIORITY_CONFIG: Record<
  AnnouncementPriority,
  { label: string; color: string }
> = {
  [AnnouncementPriority.NORMAL]: { label: "Normal", color: "default" },
  [AnnouncementPriority.IMPORTANT]: { label: "Important", color: "warning" },
  [AnnouncementPriority.URGENT]: { label: "Urgent", color: "error" },
}
